import apiClient from "../../client/apiClient"
import { appendQueryParams } from "../../utils"

export type EmployeeUser = {
  _id: string
  firstName: string
  lastName: string
  email: string
  phone?: string
  branch?: string
}

export type InOutRecord = {
  type: "in" | "out"
  time: string
  _id?: string
}

export type EmployeeAttendance = {
  _id: string
  employee: string
  user: string
  status: "present" | "absent" | "half-day" | "late" | "leave"
  branch: string
  session: string
  markedBy: string
  date: string
  remarks: string
  inOut: InOutRecord[]
  createdAt: string
  updatedAt: string
}

export type AttendanceRecord = {
  employeeId: string
  status?: "present" | "absent" | "half-day" | "late" | "leave"
  remarks?: string
  date?: string
  in?: string
  out?: string
}

export type EmployeeAttendanceData = {
  employeeId: string
  employeeCode: string
  user: EmployeeUser
  department: string
  designation: string
  branch: any
  session: any
  date: string
  attendance: EmployeeAttendance | null
  status: string
  createdAt: string
}

export type MarkAttendanceRequest = {
  attendances: AttendanceRecord[]
}

export type MarkAttendanceResponse = {
  success: boolean
  message: string
  data: EmployeeAttendance[]
}

export type GetAttendanceResponse = {
  success: boolean
  message: string
  data: EmployeeAttendanceData[]
  pagination: {
    total: number
    totalPages: number
    currentPage: number
    limit: number
    hasNextPage: boolean
    hasPrevPage: boolean
  }
}

const ATTENDANCE_ENDPOINT = {
  MARK_ATTENDANCE: "/attendance/mark-employee",
  GET_ATTENDANCE: "/attendance/employee-attendance",
  RESET_ATTENDANCE: "/attendance/reset-employee-attendance",
}

const markEmployeeAttendance = async (
  data: MarkAttendanceRequest
): Promise<MarkAttendanceResponse> => {
  const response = await apiClient({
    url: ATTENDANCE_ENDPOINT.MARK_ATTENDANCE,
    method: "POST",
    data,
  })
  return response.data
}

const getEmployeeAttendance = async ({
  branchId,
  sessionId,
  date,
  search = "",
  sortBy,
  sortOrder,
  page = 1,
  limit = 10,
}: {
  branchId?: string
  sessionId?: string
  date?: string
  search?: string
  sortBy?: string
  sortOrder?: string
  page?: number
  limit?: number
} = {}): Promise<GetAttendanceResponse> => {
  const response = await apiClient({
    url: appendQueryParams(ATTENDANCE_ENDPOINT.GET_ATTENDANCE, {
      branchId,
      sessionId,
      date,
      search,
      sortBy,
      sortOrder,
      page,
      limit,
    }),
    method: "GET",
  })
  return response.data
}

 const resetEmployeeAttendance = async ({
  date,
  employeeIds,
  branchId,
}: {
  date: string
  employeeIds: string[]   // Sirf ek ID bhi daal sakte ho array mein
  branchId?: string
}): Promise<{ success: boolean; message: string; deletedCount: number }> => {
  const response = await apiClient({
    url: ATTENDANCE_ENDPOINT.RESET_ATTENDANCE,
    method: "DELETE",
    data: {
      date,
      employeeIds,
      branchId, // optional
    },
  })

  return response.data
}

// Export sab functions
export { markEmployeeAttendance, getEmployeeAttendance, resetEmployeeAttendance }